// A year's Google Sheet, kept by the fullstack: {program, speakers, "session-chairs",
// organizers}, each an array of rows with the header row first (fullstack
// claude/SHEET-UPDATE-SPEC.md). Fetched once per year; an Update replaces the copy.
import {ref} from "vue";

const sheets = {};
// bumped when a year's copy is replaced, for views to reload
export const sheetVersion = ref(0);

async function fetchSheet(year) {
  try {
    const response = await fetch(`/events/${year}/program.json`);
    if (!response.ok) return {};
    return await response.json();
  } catch (error) {
    console.error(`Fetching the sheet for ${year}: ${error}`);
    return {};
  }
}

export function fetchProgramSheet(year) {
  if (!year) return Promise.resolve({});
  if (!sheets[year]) sheets[year] = fetchSheet(year);
  return sheets[year];
}

export function setProgramSheet(year, data) {
  sheets[year] = Promise.resolve(data || {});
  sheetVersion.value += 1;
}
